module.exports = __webpack_public_path__ + "media/images/front/banner_premium-94d621c99501059aa0f0524c223b8dcb.jpg";